import { render, staticRenderFns } from "./_FormEditarResposta.vue?vue&type=template&id=081cb0dc&scoped=true"
import script from "./_FormEditarResposta.vue?vue&type=script&lang=ts"
export * from "./_FormEditarResposta.vue?vue&type=script&lang=ts"
import style0 from "./_FormEditarResposta.vue?vue&type=style&index=0&id=081cb0dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081cb0dc",
  null
  
)

export default component.exports